module.exports = __webpack_public_path__ + "assets/img/ke_fu_tu.3dafa0f9.png";